<template>
	<div id="app">

		<div v-if="status === 0 || status === 2" class="page-status">
			<div class="status-loading" v-if="status === 0">
				<div class="lds-spinner">
					<div
						v-for="n in 12"
						:key="n"
					/>
				</div>
			</div>

			<div class="status-error" v-if="status === 2">
				<div class="oaerror danger">
					<strong>Error</strong>- {{ statusError }}.
				</div>
			</div>
		</div>

		<div v-if="status === 1">

		<div class="hero-wrapper">
			<div class="hero-content">
				<div class="logo">
					<img src="@/assets/img/logo-fidelidade.png" alt="">
				</div>
				<div class="hero-text">
					<div class="pets-logo">
						Fidelidade <span>PETS</span>
					</div>
					<div class="hero-slogan">
						O seu melhor amigo faria tudo por si.
						<span>Faça o mesmo <br> por ele.</span>
					</div>
				</div>
			</div>
		</div>

		<div class="hero-slogan only-mobile">
			O seu melhor amigo faria tudo por si.
			<span>Faça o mesmo <br> por ele.</span>
		</div>

		<div class="form-container" :class="[ stepIndex === 1 ? '-hidden' : null ]" >


			<MoForms v-if="status === 1" instruction="Confirme os seus dados:">
				<div
					v-if="stepIndex === 1"
					class="submit-response"
				>
					<ElCheckIcon v-if="!serverLoading" isValid />

				</div>

				<div class="input-fields" >

					<ElInput type="text" label="Nome e Apelido" v-model="formData.name" :validator="validations.validNAME" @validated="onValidated('name', $event)" :keypress="restrictChars" required/>

					<ElInput type="tel" :maxlength='9' label="NIF" v-model="formData.vatin" :validator="validations.validPTVATIN" @validated="onValidated('vatin', $event)" autoformat="000000000" required/>

					<ElInput type="email" label="E-mail" v-model="formData.email" :validator="validations.validEMAIL" @validated="onValidated('email', $event)" required/>

					<ElInput type="tel" label="Telemóvel" v-model="formData.mobile" :validator="validations.validPTCELL" @validated="onValidated('mobile', $event)" autoformat="000000000" :filter="filterPhoneNumber" required/>

					<ElInput type="tel" label="Código Postal" v-model="formData.postalcode" :validator="validations.validPOSTALCODE" @validated="onValidated('postalcode', $event)" placeholder="____-___" autoformat="0000-000" use-placeholder-as-mask required/>

					<p>Nos termos do atual Regulamento Geral de Proteção de Dados, é-lhe garantido o direito de consultar e retificar todos os dados pessoais cedidos, solicitar o seu apagamento, portabilidade, limitação e ainda opor-se ao seu tratamento, enviando uma mensagem para <a href="emailto:epdp@fidelidade.pt.">epdp@fidelidade.pt</a></p>

					<ElCheckInput
						label="Sim, gostaria de ser informado acerca dos vossos produtos e serviços."
						v-model="IsGdprAgreed"
					/>

					<a href="#"> Consulte aqui a nossa informação sobre a proteção e tratamento dos dados.</a>
				</div>

				<ElButton
					v-if="stepIndex === 0"
					slot="actions"
					@click="onSubmit"
					:disabled="!areInputsValid"
					text="confirmar"
				/>

				<ElButton
					v-if="stepIndex === 1"
					@click="stepIndex = 0"
					text="voltar"
					slot="submitResponse"
				/>

				<span
					v-if="stepIndex === 1"
					slot="submitResponse"
					class="servermsg"
				>
					{{ serverMessage }}
				</span>

			</MoForms>

		</div>

		<div class="middle-content main">

			<p class="color-red">Uma amizade tão fiel quanto a do seu pet precisa de ser protegida. <br>E agora já o pode fazer de forma fácil e à sua medida.</p>
			<p>Com o seguro Fidelidade Pets, para cães e gatos, tem várias opções de proteção que incluem medicina preventiva, assistência para o seu animal e diferentes cuidados de saúde associados. </p>

			<ElButton target="_blank" href="https://www.fidelidade.pt/PT/particulares/pets/Paginas/pets_ramo.aspx" type="a" text="saiba mais" />

			<div class="feature-panel">
				<div class="feature-item">
					<img class="feature-icon" width="154" src="~@/assets/img/protection.svg" alt="">
					<span class="text">4 OPÇÕES DE PROTEÇÃO</span>
				</div>
				<div class="feature-item">
					<img class="feature-icon" width="154" src="~@/assets/img/assistance.svg" alt="">
					<span class="text">Pet assistência</span>
				</div>
				<div class="feature-item">
					<img class="feature-icon" width="154" src="~@/assets/img/tele.svg" alt="">
					<span class="text">LINHA DE APOIO<br>TELEFÓNICO TELEPET</span>
				</div>
				<div class="feature-item">
					<img class="feature-icon" width="154" src="~@/assets/img/checkup.svg" alt="">
					<span class="text">OFERTA DE 1 CHECK UP <br> PERIÓDICO</span>
				</div>
			</div>
		</div>



		<div class="apps-panel">
				<div class="logo main">
					<img width="140" src="~@/assets/img/pets-logo.png" alt="">
				</div>
			<div class="red-bg">

				<div class="main">
					<div class="splash">
						<img width="230" src="~@/assets/img/splash.png" alt="">
					</div>
					<div class="content">
						<span>Ainda não tem a aplicação que sabe tudo sobre o seu pet?</span>
						<a target="_blank" href="http://onelink.to/rccuab">Descarregue já, gratuitamente.</a>
						<div class="app-icons">
							<a href="https://apps.apple.com/pt/app/mypets/id1440616030" target="_blank"> <img src="~@/assets/img/cta_apple.png" alt=""></a>
							<a href="https://play.google.com/store/apps/details?id=pt.fidelidade.vetapp&hl=pt_PT" target="_blank"> <img src="~@/assets/img/cta_google.png" alt=""></a>
						</div>
					</div>

				</div>
			</div>
		</div>

		<footer class="main">
			<div class="social-panel">
				<a target="_blank" href="https://www.fidelidade.pt">fidelidade.pt</a>
				<a target="_blank" href="https://www.facebook.com/SegurosFidelidade/"><img src="~@/assets/img/facebook.png" alt=""></a>
				<a target="_blank" href="https://www.youtube.com/user/SegurosFidelidade"><img src="~@/assets/img/youtube.png" alt=""></a>
				<a target="_blank" href="https://www.linkedin.com/company/fidelidade/"><img src="~@/assets/img/linkedin.png" alt=""></a>
				<a target="_blank" href="https://www.instagram.com/fidelidade.seguros/"><img src="~@/assets/img/instagram.png" alt=""></a>
			</div>
			<div class="contact">
				<span> Esta informação não dispensa a consulta de informação pré-contratual e contratual legalmente exigida.</span>

				<span>
					Fidelidade - Companhia de Seguros, S.A. - NIPC e Matrícula 500 918 880, na CRC Lisboa - Sede: Largo do Calhariz, 30 1249-001 Lisboa - Portugal - Capital Social € 457 380 000 - <a target="_blank" href="https://www.fidelidade.pt">www.fidelidade.pt</a>
					<br>
					<strong>
						Linha de Apoio ao Cliente: T. 808 29 39 49 - E. <a target="_blank" href="mailto:apoiocliente@fidelidade.pt">apoiocliente@fidelidade.pt</a> - Atendimento telefónico personalizado nos dias úteis das 8h às 23h e Sábados das 8h às 20h.
					</strong>
				</span>
			</div>
		</footer>
		</div>
	</div>
</template>

<script>
import MoForms from './components/MoForms.vue'
import ElInput from './components/ElInput.vue'
import ElButton from './components/ElButton.vue'
import ElCheckIcon from './components/ElCheckIcon';
import ElCheckInput from './components/ElCheckInput.vue'
import * as validations from './utils/validator';
import axios from 'axios';

export default {
name: 'app',
	components: {
		MoForms,
		ElInput,
		ElButton,
		ElCheckInput,
		ElCheckIcon
	},
	data() {
		return {
			validations,
			stepIndex: 0,
			status: -1,
			statusError: null,
			IsGdprAgreed: false,
			formData: {
				uid: null,
				name: null,
				vatin: null,
				email: null,
				mobile: null,
				postalcode: null
			},
			valid: {
				name: false,
				vatin: false,
				email: false,
				mobile: false,
				postalcode: false
			},
			serverLoading: false,
			serverMessage: ''
		}
	},
	computed: {
		areInputsValid() {
			let valid = this.valid.name && this.valid.email && this.valid.mobile && this.valid.postalcode && this.IsGdprAgreed;
			return valid;
		}
	},
	mounted() {
		this.loadformData();
	},
	methods: {
		restrictChars($e) {
			if ( ($e.charCode > 64 && $e.charCode < 91) || ($e.charCode > 96 && $e.charCode < 123) || $e.charCode === 32) {
				return true
			} else {
				$e.preventDefault();
			}
		},
		loadformData() {
			// FIRST STEP: tell the whole app that we're loading.
			// this will allow you to show an indicator or something.
			this.status = 0;

			// SECOND STEP: grab the ID from the URL.
			// it would probably be formatted as something like:
			// https://fidelidade.digital/vpdcconfirm/?id=972e6b0bf0ecf85b13355d6ac1ce0436d645f9da
			const uid = this.getUrlParameter('id');
			if (!uid) {
				this.status = 2;
				this.statusError = 'invalid ID'; // TODO: deal with no ID in URL
				return;
			}

			// THIRD STEP: grab the user info.
			// we already have the ID, so let's call the database.
			axios
				.post('https://fidelidade.digital/vpdcconfirm/getstore.php', { uid })
				.then(({ data }) => {
					// FOURTH STEP: apply the user info to the form.
					// we probably received user data, but we need to confirm first.
					if (data.ok) {
						if (data.resultcount > 0) {
							this.status = 1;
							this.formData = { ...data.values, uid };
						}
						else {
							this.status = 2;
							this.statusError = 'invalid ID'; // TODO: deal with NON-EXISTING ID
						}
					}
					else {
						this.status = 2;
						this.statusError = data.error; // TODO: deal with SERVER error
					}
				})
				.catch((e) => {
					this.status = 2;
					this.statusError = e.message; // TODO: deal with REQUEST error
				});
		},
		goToPreviousStep() {
			this.stepIndex--;
		},
		goToNextStep() {
			this.stepIndex++;
		},
		filterPhoneNumber(value, index) {
			return index !== 0 || value === '9';
		},
		onValidated(key, valid) {
			this.valid[key] = valid;
		},
		onSubmit() {
			this.serverLoading = true;
			this.serverMessage = 'A submeter...';
			this.stepIndex++;

			axios
				.post('https://fidelidade.digital/vpdcconfirm/updatestore.php', this.formData)
				.then(({ data }) => {
					if (data.ok) {
						this.serverMessage = 'Submissão concluída com sucesso!';
						this.serverLoading = false;
					}
					else {
						this.serverMessage = 'Ocorreram erros na submissão. Por favor tente de novo.';
						console.log(data);
					}
				})
				.catch(() => {
					this.serverMessage = 'Ocorreu um erro de servidor.';
				});
		},
		// function to grab parameters from url...
		// taken from https://davidwalsh.name/query-string-javascript
		getUrlParameter(name) {
			name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
			var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
			var results = regex.exec(location.search);
			return !results || !results[1] ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
		}
	}
}
</script>

<style lang="scss">
@import "assets/sass/variables";
@import "assets/sass/media-queries";


#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	height: auto;
	background-color: #F9F9F9;

	.container {
		max-width: 120.80rem;
		margin: 0 auto;
	}

	.page-status {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);

		height: 100%;
		width: 100%;
		background: #f1f1f1;

		.status-loading {
			display: flex;
			height: 100%;
			justify-content: center;
			align-items: center;

			.lds-spinner {
				color: official;
				display: inline-block;
				position: relative;
				width: 64px;
				height: 64px;
			}

			.lds-spinner div {
				transform-origin: 32px 32px;
				animation: lds-spinner 1.2s linear infinite;
			}

			.lds-spinner div:after {
				content: " ";
				display: block;
				position: absolute;
				top: 3px;
				left: 29px;
				width: 5px;
				height: 14px;
				border-radius: 20%;
				background: $color-main;
			}

			.lds-spinner div:nth-child(1) {
				transform: rotate(0deg);
				animation-delay: -1.1s;
			}

			.lds-spinner div:nth-child(2) {
				transform: rotate(30deg);
				animation-delay: -1s;
			}

			.lds-spinner div:nth-child(3) {
				transform: rotate(60deg);
				animation-delay: -0.9s;
			}

			.lds-spinner div:nth-child(4) {
				transform: rotate(90deg);
				animation-delay: -0.8s;
			}

			.lds-spinner div:nth-child(5) {
				transform: rotate(120deg);
				animation-delay: -0.7s;
			}

			.lds-spinner div:nth-child(6) {
				transform: rotate(150deg);
				animation-delay: -0.6s;
			}

			.lds-spinner div:nth-child(7) {
				transform: rotate(180deg);
				animation-delay: -0.5s;
			}

			.lds-spinner div:nth-child(8) {
				transform: rotate(210deg);
				animation-delay: -0.4s;
			}

			.lds-spinner div:nth-child(9) {
				transform: rotate(240deg);
				animation-delay: -0.3s;
			}

			.lds-spinner div:nth-child(10) {
				transform: rotate(270deg);
				animation-delay: -0.2s;
			}

			.lds-spinner div:nth-child(11) {
				transform: rotate(300deg);
				animation-delay: -0.1s;
			}

			.lds-spinner div:nth-child(12) {
				transform: rotate(330deg);
				animation-delay: 0s;
			}

			@keyframes lds-spinner {
				0% {
					opacity: 1;
				}

				100% {
					opacity: 0;
				}
			}
		}
		.status-error {
			display: flex;
			height: 100%;
			justify-content: center;
			align-items: center;

			.oaerror {
				background-color: #ffffff;
				padding:20px;
				border:1px solid #eee;
				border-left-width:5px;
				border-radius: 3px;
				margin:10px auto;
				font-family: 'Open Sans', sans-serif;
				font-size: 16px;
				&.danger{
					border-left-color: #d9534f; /* Left side border color */
					background-color: rgba(217, 83, 79, 0.1); /*Same color as the left border with reduced alpha to 0.1*/
				}

				&.danger strong{
					color:#d9534f;
				}
			}
		}
	}
	.hero-wrapper {
		padding: 5rem;
		background-image: url('./assets/img/hero-bg.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		font-family: 'Lato', sans-serif;
		max-width: 2000px;
		margin: 0 auto;
		position: relative;
		z-index: 1;

		@include min-screen($large) {
			padding: 10rem;
		}

		@include max-screen($medium) {
			padding: 5rem;
			background-position: 80% center;
		}

		.hero-content {
			max-width: 128.4rem;
			margin: 0 auto;
		}

		.logo {
			padding-bottom: 10rem;

			> img {
				max-width: 100%;
				width: 32rem;
				@include max-screen($xsmall) {
					width: 30rem;
				}
			}
		}
		.pets-logo {
			text-transform: uppercase;
			font-size: 3rem;
			font-weight: 300;
			margin: 1.5rem 0;
			color: $color-main;

			span {
				font-weight: 900;
			}
			@include max-screen($xsmall) {
				font-size: 2.8rem;
			}
		}
		.hero-slogan {
			font-size: 3.6rem;
			font-weight: 500;
			line-height: 4.7rem;
			max-width: 45rem;
			text-transform: uppercase;
			color: $color-text;
			padding-bottom: 10rem;

			span {
				display: block;
				color: $color-main;
			}
		}

		@include max-screen($xsmall) {
			padding: 2rem 2rem 18rem;
			background-position: 75% center;
			.hero-content {
				.logo {
					padding-bottom: 5rem;
				}
			}
			.hero-slogan {
				display: none;
			}
		}
	}
	.only-mobile {
		display: none;
		@include max-screen($xsmall) {
			display: block;
		}

		&.hero-slogan {
			font-size: 3.2rem;
			font-weight: 500;
			line-height: 4rem;
			text-transform: uppercase;
			color: #2C363E;
			padding: 2rem;
			background: #f9f9f9;
			top: -3rem;
		//	margin-bottom: -3rem;
			position: relative;
			margin: 0 1rem;
			margin-bottom: -3rem;
			z-index: 2;

			span {
				display: block;
				color: $color-main;
			}
		}
	}


	.form-container {
		margin-top: -6rem;
		position: relative;
		z-index: 3;

		@include max-screen($xsmall) {
			margin-top: 0;
		}

		.submit-response  {
			display: none;
			position: absolute;
			bottom: 0%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%);
			z-index: 99;
		}
		.servermsg {
			position: absolute;
			bottom: 1.5rem;
			font-weight: 600;
			font-size: 1.8rem;
			color: green;
		}

		&.-hidden {

			.submit-response {
				display: flex;
				flex-direction: column;
				width: 100%;
				align-items: center;

				> .el-check-icon {
					transform: scale(2) translateY(-1rem);
				}
			}
			.input-fields {
				opacity: 0.05;
				pointer-events: none
			}
		}
	}
	.main {
		max-width: 104rem;
		margin: 0 auto;
		padding-left: 2rem;
		padding-right: 2rem;
	}

	.middle-content {
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		padding: 7rem 2rem 4rem;

		> .color-red {
			color: $color-main;
			font-size: 3rem;
			line-height: 4rem;
			font-weight: 400;
		}

		> p {
			color: $color-text;
			font-size: 2.4rem;
			line-height: 4rem;
			font-weight: 300;
			margin-bottom: 3rem;
			max-width: 100%;
		}
		> .el-button {
			margin-top: 3rem;
		}

		.feature-panel {
			display: flex;
			flex-wrap: wrap;
			margin: 5rem 0;
			justify-content: space-between;
			width: 100%;

			@include max-screen($xsmall) {
				flex-direction: column;
			}

			.feature-item {
				flex: 0 48%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				background: #EEEEEE;
				min-height: 32rem;
				margin-bottom: 4%;

				@include max-screen($xsmall) {
					flex: 1;
					padding: 2rem;
				}

				> .feature-icon {
					justify-content: flex-start;
				}
				> .text {
					font-weight: 600;
					text-transform: uppercase;
					font-size: 3rem;
					padding-top: 2rem;

					@include max-screen($medium) {
						font-size: 2.5rem;
					}
				}
			}
		}
	}
	.apps-panel {
		position: relative;
		padding-top: 12rem;
		background: #fff;

		@include max-screen($xsmall) {
			justify-content: center;
			display: flex;
			flex-direction: column;
			padding-top: 15rem;
		}

		> .logo {
			padding: 2rem;
			padding-left: 38rem;

			@include max-screen($xsmall) {
				padding-left: 0;
				position: relative;
				top: -10rem;
			}

		}

		.red-bg {
			background: $color-main;
			> .main {
				position: relative;

				@include max-screen($xsmall) {
					display: flex;
					flex-direction: column;
					align-items: center;
				}
			}
			.splash {
				position: absolute;
				left: 10rem;
				bottom: -3px;

				@include max-screen($xsmall) {
					position: relative;
					left: auto;
					bottom: auto;
					margin-top: -10rem;
				}
			}
			.content {
				padding-left: 38rem;
				padding-top: 2rem;
				padding-bottom: 2rem;

				display: flex;
				flex-direction: column;

				a, span {
					color: #fff;
					font-size: 1.8rem;
					font-weight: 600;
				}

				a {
					text-decoration: underline;
					margin: 1rem 0;
				}

				.app-icons {
					padding: 1rem 0;

					> a {
						margin-right: 2rem;
					}
				}

				@include max-screen($xsmall) {
					padding: 2rem;
				}
			}
		}

	}

	footer {
		padding: 3rem 0;

		.social-panel {
			display: flex;
			justify-content: flex-end;
			align-items: center;

			> a {
				font-size: 2rem;
				font-weight: 600;
				color: $color-main;
			}

			> * {
				margin-left: 1rem;
			}
		}
		.contact {
			padding: 2rem 0;

			> span {
				font-size: 1.6rem;
			}

			span:first-of-type {
				margin-bottom: 2rem;
				display: block;
			}
		}
	}
}
</style>
